import React, {Component} from 'react';

class Footer extends Component {
	render(){
		return(
            <footer className="main-footer">
                <div className="container-fluid">
                    <div className="copyright">
                        Şanlıurfa Eczacı Odası Portal Uygulaması - PORTAL V1.0.0
                    </div>
                </div>
            </footer>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/layout/Footer.js